import React from 'react';
import styled from 'styled-components';

import { Nullable } from '@tager/web-core';

import { PostFull } from '@/typings/model';
import { colors } from '@/constants/theme';
import Share from '@/components/Share';

import Hero from './components/Hero';
import Excerpt from './components/Excerpt';
import Tags from './components/Tags';
import Description from './components/Description';

type Props = {
  post: Nullable<PostFull>;
};

const MainView = ({ post }: Props) => {
  return (
    <Component>
      <Hero
        title={post?.pageTitle ?? ''}
        image={post?.image.inner}
        categories={post?.categories ?? []}
      />
      {post?.excerpt && <Excerpt text={post.excerpt} />}
      {post?.body && (
        <Body
          className="post-body-wrapper"
          dangerouslySetInnerHTML={{ __html: post.body }}
        />
      )}
      {post?.pageDescription && (
        <Description
          description={post.pageDescription}
          className="blog-post-description"
        />
      )}

      {post?.tags && post?.tags.length > 0 && (
        <Tags tags={post.tags} className="blog-post-tags" />
      )}
      <Share postTitle={post?.title ?? ''} className="blog-post-share" />
    </Component>
  );
};

export default MainView;

const Component = styled.div`
  .post-body-wrapper {
    p {
      margin-top: 1.6875rem;
    }

    p:first-child {
      margin-top: 0.875rem;
    }

    img {
      margin: 1.5625rem auto 0;
    }

    h2 {
      margin: 1.875rem 0 0.9375rem;
    }

    p a {
      color: ${colors.primary};
      text-decoration: underline;
    }
  }

  .blog-post-tags {
    margin-top: 1.4375rem;
  }
  .blog-post-description {
    margin-top: 1.625rem;
  }
  .blog-post-share {
    margin-top: 1rem;
  }
`;
const Body = styled.div`
  
`;
